import { HoverCard } from "components/HoverCard"
import { IReport, ReportStatusEnum } from "interfaces/Report"
import * as S from './styles'
import { useRef } from "react"

type ReportSummaryProps = {
  reports: IReport[] | undefined;
  attachmentsClick: (report?: IReport) => void
}

const statusConvert: { [key in ReportStatusEnum]?: string } = {
  'aguardando': 'Aguardando estimativa',
  'em-percurso': 'A caminho',
  'associado': 'Aguardando estimativa'
}

export function ReportSummary({ reports, attachmentsClick }: ReportSummaryProps) {
  const hoverCardContainerRef = useRef<HTMLDivElement>(null)

  if (!reports) return null

  const policemenInRoute = reports.filter(({ status }) => ['aguardando', 'em-percurso', 'associado'].includes(status))

  const policemenInLocation = reports.filter(({ status }) => status === 'andamento')

  const policemenToApprove = reports.filter(({ status }) => ['aprovacao', 'reprovado', 'semi-concluido'].includes(status))

  const policemenFinished = reports.filter(({ status }) => status === 'concluido')

  return (
    <div className="pr-status-container">
      <span>Status dos PR's</span>

      <div className="pr-status-hover-cards">
        {policemenInRoute.length > 0 && (
          <S.HoverCardContainer ref={hoverCardContainerRef}>
            <HoverCard.Root>
              <HoverCard.Trigger className="hover-card-trigger">
                Em percurso ({policemenInRoute.length})
              </HoverCard.Trigger>

              <HoverCard.Content
                className="hover-card-content"
                contentContainer={hoverCardContainerRef.current}
              >
                <S.HoverInfo>
                  {policemenInRoute.map((report) => {
                    const policemanName = report.policeman?.user?.name
                    const superficialPolicemanName = report.superficialPoliceman?.name

                    return (
                      <div className="pr-info">
                        <span>{superficialPolicemanName ?? policemanName}</span>
                        <span>{statusConvert[report.status]}</span>
                      </div>
                    )
                  })}
                </S.HoverInfo>
              </HoverCard.Content>
            </HoverCard.Root>
          </S.HoverCardContainer>
        )}

        {policemenInLocation.length > 0 && (
          <S.HoverCardContainer ref={hoverCardContainerRef}>
            <HoverCard.Root>
              <HoverCard.Trigger className="hover-card-trigger">
                No local ({policemenInLocation.length})
              </HoverCard.Trigger>

              <HoverCard.Content
                className="hover-card-content"
                contentContainer={hoverCardContainerRef.current}
              >
                <S.HoverInfo>
                  {policemenInLocation.map((report) => {
                    const policemanName = report.policeman?.user?.name
                    const superficialPolicemanName = report.superficialPoliceman?.name

                    return (
                      <div className="pr-info">
                        <span>{superficialPolicemanName ?? policemanName}</span>
                      </div>
                    )
                  })}
                </S.HoverInfo>
              </HoverCard.Content>
            </HoverCard.Root>
          </S.HoverCardContainer>
        )}


        {policemenToApprove.length > 0 && (
          <S.HoverCardContainer ref={hoverCardContainerRef}>
            <HoverCard.Root>
              <HoverCard.Trigger className="hover-card-trigger">
                Aguardando validação ({policemenToApprove.length})
              </HoverCard.Trigger>

              <HoverCard.Content
                className="hover-card-content"
                contentContainer={hoverCardContainerRef.current}
              >
                <S.HoverInfo>
                  {policemenToApprove.map((report) => {
                    const policemanName = report.policeman?.user?.name
                    const superficialPolicemanName = report.superficialPoliceman?.name

                    return (
                      <div className="pr-info">
                        <span>{superficialPolicemanName ?? policemanName}</span>
                        <button onClick={() => attachmentsClick(report)}>Ver anexos</button>
                      </div>
                    )
                  })}
                </S.HoverInfo>
              </HoverCard.Content>
            </HoverCard.Root>
          </S.HoverCardContainer>
        )}

        {policemenFinished.length > 0 && (
          <S.HoverCardContainer ref={hoverCardContainerRef}>
            <HoverCard.Root>
              <HoverCard.Trigger className="hover-card-trigger">
                Concluidos ({policemenFinished.length})
              </HoverCard.Trigger>

              <HoverCard.Content
                className="hover-card-content"
                contentContainer={hoverCardContainerRef.current}
              >
                <S.HoverInfo>
                  {policemenFinished.map((report) => {
                    const policemanName = report.policeman?.user?.name
                    const superficialPolicemanName = report.superficialPoliceman?.name

                    return (
                      <div className="pr-info">
                        <span>{superficialPolicemanName ?? policemanName}</span>
                      </div>
                    )
                  })}
                </S.HoverInfo>
              </HoverCard.Content>
            </HoverCard.Root>
          </S.HoverCardContainer>
        )}
      </div>
    </div>
  )
}